import { TextField } from 'opensolar-ui'
import { useState } from 'react'
import { Component } from './Component'
import { GeminiLiveAPIProvider } from './GeminiLiveAPIContext'

const host = 'generativelanguage.googleapis.com'
const uri = `wss://${host}/ws/google.ai.generativelanguage.v1alpha.GenerativeService.BidiGenerateContent`

const GeminiLiveAPIEmbed = () => {
  /**
   * Beware: This method is not secure and must not be used in production because it would expose an API key.
   * We allow the user to type in their API key for testing purposes which is acceptable because it will not
   * be exposed to any other users.
   *
   * Allow user to set API key in local storage for convenience.
   */
  const [apiKey, setApiKey] = useState<string | undefined>(
    window.localStorage.getItem('gemini-live-api-key') || undefined
  )
  const [apiKeyRaw, setApiKeyRaw] = useState<string | undefined>(undefined)

  return apiKey ? (
    <GeminiLiveAPIProvider url={uri} apiKey={apiKey}>
      <Component />
      <button onClick={() => setApiKey(undefined)}>Clear API Key</button>
    </GeminiLiveAPIProvider>
  ) : (
    <div>
      <TextField label="Gemini Live API Key" value={apiKey} onChange={(e) => setApiKeyRaw(e.target.value)} />
      <button style={{ verticalAlign: 'bottom' }} onClick={() => setApiKey(apiKeyRaw)}>
        Set
      </button>
      <button
        style={{ verticalAlign: 'bottom' }}
        onClick={() => {
          setApiKey(apiKeyRaw)
          window.localStorage.setItem('gemini-live-api-key', apiKeyRaw || '')
        }}
      >
        Set & Save
      </button>
    </div>
  )
}

export default GeminiLiveAPIEmbed
